module.exports = __webpack_public_path__ + "static/media/skype_logo.e68e904d.png";